export const isInternalPath = (path: string | undefined): boolean => {
  if (!path) return false;
  // Reject absolute URLs (http://, https://, javascript:, etc.)
  if (/^[a-z][a-z0-9+.-]*:/i.test(path)) return false;
  // Reject protocol-relative URLs (//evil.com)
  if (path.startsWith('//')) return false;
  // Accept paths starting with /
  return path.startsWith('/');
};

export const normalizeReturnURI = (rawReturnURI: string | undefined): string => {
  if (!rawReturnURI || rawReturnURI === '/login' || !isInternalPath(rawReturnURI)) {
    return '/';
  }
  return rawReturnURI;
};
